
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { X, Plus } from "lucide-react";

interface TagsListProps {
  tags: string[];
  updateTag: (index: number, value: string) => void;
  removeTag: (index: number) => void;
  addTag: () => void;
}

const TagsList: React.FC<TagsListProps> = ({
  tags,
  updateTag,
  removeTag,
  addTag,
}) => {
  return (
    <div className="space-y-2">
      <Label>Tags</Label>
      <div className="space-y-2">
        {tags.map((tag, index) => (
          <div key={`tag-${index}`} className="flex gap-2">
            <Input
              value={tag}
              onChange={(e) => updateTag(index, e.target.value)}
              placeholder="Enter a tag (e.g. Christmas, Holiday)"
              className="flex-1"
            />
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => removeTag(index)}
              disabled={tags.length <= 1}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
        <Button
          type="button"
          variant="outline"
          onClick={addTag}
          className="mt-2"
        >
          <Plus className="h-4 w-4 mr-2" /> Add Tag
        </Button>
      </div>
    </div>
  );
};

export default TagsList;
